import React, { useEffect, useState } from 'react';

import cn from 'classnames';

import HistoryIcon from '@/assets/img/history.svg?react';
import HistoryCard from '@/components/common/HistoryCard/HistoryCard';
import styles from './history.module.scss';
import searchStyles from './history-search.module.scss';
import { useGetHistoryAuditData } from './hooks/useGetHistoryAuditData';
import { ContractAuditData } from '@/graphql/contracts/_generated_/ContractAudit.fragment';
import { useSearchUsers } from '@/hooks/identity/useSearchUsers';
import { User } from '@/hooks/identity/responseModels/user';
import { useHistorySearch } from './hooks/useHistorySearch';
import HistorySearchHeader from '@/components/common/HistorySearch/HistorySearchHeader';


export default function HistoryContainer() {
  const { auditHistoryData, isLoadingAuditHistory, isCalledAuditData, auditHistoryError } = useGetHistoryAuditData();
  const { searchUsers, isLoadingSearchUsers } = useSearchUsers();
  const [users, setUsers] = useState<User[]>([]);

    
  const { 
    searchTerm, 
    filteredHistoryData, 
    handleSearchChange, 
    dateFilter, 
    handleDateFilterChange 
  } = useHistorySearch({
    auditHistoryData,
    isLoadingSearchUsers,
    users,
  });

  const noHistoryRecordFound = isCalledAuditData && !auditHistoryData && !isLoadingAuditHistory
    && !auditHistoryError;

  const historyStatusMessage = noHistoryRecordFound ? 'History doesn\'t contain any records yet' :
    auditHistoryError ? auditHistoryError.message : 'History is loading. Please wait...';

  const isHistoryIconVisible = isCalledAuditData && (isLoadingAuditHistory || auditHistoryData.length === 0);

  useEffect(() => {
    if (isCalledAuditData && !isLoadingAuditHistory) {
      const getUsers = async () => {
        const userIds = auditHistoryData.map(history => history.eventSourceId).filter(id => !!id) as string[];
        const uniqueUserIds = new Set(userIds);
        const searchResult = await searchUsers({ ids: [...uniqueUserIds] });
        setUsers(searchResult);
      };

      getUsers();
    }
  }, [isCalledAuditData, isLoadingAuditHistory, auditHistoryData, searchUsers]);


  return (
    <>
      <HistorySearchHeader
        title="History"
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        date={dateFilter.startDate}
        onDateChange={(d) => handleDateFilterChange(d, null)}
        showClear={!!dateFilter.startDate}
      />
      {isHistoryIconVisible &&
        (<div className="d-flex align-items-center c-title mt-20 flex-column">
          <div className={styles['history-container']}>
            <HistoryIcon className={cn({
              [styles['loading-icon']]: isLoadingAuditHistory
            })} />
          </div>
          {historyStatusMessage}
        </div>)}
      {filteredHistoryData.length > 0 && !isLoadingSearchUsers && (
        <div className={searchStyles.historyContent}>
          {filteredHistoryData.map((el: ContractAuditData) => (
            <div
              key={el.changeSetID}
              className={searchStyles.historyItem}
            >
              <HistoryCard
                historyItem={el}
                user={users.find(user => user.Id == el.eventSourceId)}
                isLoading={isLoadingSearchUsers} />
            </div>
          ))}
        </div>)}
      {(searchTerm.trim() || dateFilter.startDate) && 
       filteredHistoryData.length === 0 && auditHistoryData.length > 0 && !isLoadingSearchUsers && (
        <div className={searchStyles.noResultsMessage}>
          <span>No history records found matching your filters.</span>
        </div>
      )}
    </>
  );
}
